import fetchival from 'fetchival';
import config from '../../config/config';

const Orders = fetchival(config.API_BASE_URL + '/orders');

class OrdersApi {
  static create(order) {
    return Orders.post(order);
  }

  static confirm(orderId, code) {
    const confirmApi = Orders(orderId + '/confirm');
    return confirmApi.post({ code });
  }
}

export default OrdersApi;



// WEBPACK FOOTER //
// ./src/api/orders/ordersApi.js